import { Skeleton } from '@/ui/skeleton'

export const PlaybookPendingComponent = () => {
    return (
        <div className="flex h-full flex-row">
            <div className="hidden md:flex shrink-0 border-l border-r border-border w-[400px] bg-muted">
                <div className="flex flex-col w-full p-4 gap-4">
                    <Skeleton className="h-12 w-full" />
                    <Skeleton className="h-8 w-24" />
                    <div className="space-y-2">
                        <Skeleton className="h-16 w-full" />
                        <Skeleton className="h-16 w-full" />
                        <Skeleton className="h-16 w-full" />
                    </div>
                </div>
            </div>
            <div className="flex-1 min-w-0 overflow-auto bg-background">
                <div className="p-6 space-y-6">
                    <Skeleton className="h-8 w-48" />
                    <Skeleton className="h-64 w-full" />
                    <Skeleton className="h-64 w-full" />
                </div>
            </div>
        </div>
    )
}
